import { ApiClient } from './client'
import { AuthApi } from './endpoints/auth'
import { CampaignApi } from './endpoints/campaigns'
import { CustomerApi } from './endpoints/customers'
import { OrganisationApi } from './endpoints/organisations'
import { UserApi } from './endpoints/users'
import { PhishingKitApi } from './endpoints/phishingKits'
import { AnalyticsApi } from './endpoints/analytics'
import { TargetPoolApi } from './endpoints/targetPool'
import { InvitationApi } from './endpoints/invitations'

class PhisheezApi {
  private client: ApiClient
  
  public auth: AuthApi
  public campaigns: CampaignApi
  public customers: CustomerApi
  public organisations: OrganisationApi
  public users: UserApi
  public phishingKits: PhishingKitApi
  public analytics: AnalyticsApi
  public targetPool: TargetPoolApi
  public invitations: InvitationApi

  constructor() {
    this.client = new ApiClient()
    
    // Initialize all endpoint modules
    this.auth = new AuthApi(this.client)
    this.campaigns = new CampaignApi(this.client)
    this.customers = new CustomerApi(this.client)
    this.organisations = new OrganisationApi(this.client)
    this.users = new UserApi(this.client)
    this.phishingKits = new PhishingKitApi(this.client)
    this.analytics = new AnalyticsApi(this.client)
    this.targetPool = new TargetPoolApi(this.client)
    this.invitations = new InvitationApi(this.client)
  }

  // Token management
  setToken(token: string | null): void {
    this.client.setToken(token)
  }

  getToken(): string | null {
    return this.client.getToken()
  }

  // Direct request method for custom API calls
  async request<T = unknown>(endpoint: string, options?: RequestInit): Promise<T> {
    return this.client.request<T>(endpoint, options)
  }

  // Health check
  async healthCheck(): Promise<{ status: string; services: Record<string, any> }> {
    return this.client.get<{ status: string; services: Record<string, any> }>('/v1/health')
  }
}

// Create singleton instance
const api = new PhisheezApi()

// Export the singleton as default
export default api

// Also export types and error class for convenience
export * from './types'
export { ApiError } from './errors/ApiError'

// Export individual APIs for specific imports if needed
export {
  AuthApi,
  CampaignApi,
  CustomerApi,
  OrganisationApi,
  UserApi,
  PhishingKitApi,
  AnalyticsApi,
  TargetPoolApi,
  InvitationApi
}
